export const saveAuthenticatedSession = (result) => {
  if (!result?.token || !result?.userInfo) throw new Error('登入回應缺少使用者資料。');
  const serializedUser = JSON.stringify(result.userInfo);
  sessionStorage.setItem('user', serializedUser);
  sessionStorage.setItem('token', result.token);
  localStorage.setItem('user', serializedUser);
  localStorage.setItem('token', result.token);
  if (result.userInfo.channel != null) localStorage.setItem('qtOption', result.userInfo.channel);
  if (result.userInfo.readingPlan != null) localStorage.setItem('yearReadOption', result.userInfo.readingPlan);
  if (result.userInfo.language) localStorage.setItem('userLanguage', result.userInfo.language);
};

export const consumePostLoginRedirect = () => {
  if (typeof window === 'undefined') return '/';
  const pendingUrl = sessionStorage.getItem('postLoginRedirect');
  sessionStorage.removeItem('postLoginRedirect');
  if (!pendingUrl) return '/';
  try {
    const target = new URL(pendingUrl, window.location.origin);
    if (target.origin !== window.location.origin) return '/';
    return `${target.pathname}${target.search}${target.hash}` || '/';
  } catch (_) {
    return '/';
  }
};
